/**
 *
 * ActiveTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import CircleIcon from 'assets/v2/CircleIcon';
import { COLORS } from 'theme';

import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.green};
    background: ${COLORS.budGreenLight};
    border-color: ${COLORS.green};

    &&& .MuiChip-icon path {
      fill: ${COLORS.green};
    }
  }
`;

const ActiveTag = (props) => (
  <StyledTag label="Create" icon={<CircleIcon />} {...props} />
);

export default memo(ActiveTag);
